<template>
  <div class="index">
    <!-- 筛选 -->
    <section>
      <el-form class="section-filter" :model="filterForm" :inline="true" label-width="100px">
        <div class="filter-col">
          <el-form-item label="对象姓名：">
            <el-input clearable v-model="filterForm.user.u_nickName" placeholder="请输入对象姓名"></el-input>
          </el-form-item>
          <el-form-item label="对象身份证：">
            <el-input clearable v-model="filterForm.user.u_idCard" placeholder="请输入对象身份证"></el-input>
          </el-form-item>
        </div>
        <div class="filter-area">
          <div class="filter-area-label">地区：</div>
          <AreaPicker ref="AreaPicker" @getData="filterHandler" />
        </div>
        <div class="filter-btn">
          <el-button type="primary" @click="filterHandler()" icon="el-icon-search">查询</el-button>
          <el-button type="" @click="resetHandler()" icon="el-icon-refresh-right">重置</el-button>
        </div>
      </el-form>
    </section>
    <!-- 用户操作按钮 -->
    <section class="section-btns">
      <el-button type="" icon="el-icon-view" @click="viewHandler" v-if="btnShow.search" :disabled="selectRows.length!==1">查看</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="createHandler" v-if="btnShow.create">创建</el-button>
      <el-button type="primary" icon="el-icon-edit" @click="modifyHandler" v-if="btnShow.modify" :disabled="selectRows.length!==1">编辑</el-button>
      <!-- <el-upload
        :action="importAction"
        accept=".xls,.xlsx" :limit="1" style="margin:0 10px;" :file-list="importFiles"
        :before-upload="beforeImport" :on-success="importSuccess" v-if="btnShow.import">
        <el-button type="success" icon="el-icon-upload2">数据导入</el-button>
      </el-upload>
      <el-button type="success" icon="el-icon-download" @click="downloadHandler">下载模板</el-button> -->
      <el-button type="danger" icon="el-icon-delete" @click="deleteHandler" :disabled="selectRows.length<1" v-if="btnShow.delete">删除</el-button>
    </section>
    <!-- 数据表格 -->
    <section class="table">
      <el-table :data="tableData" max-height="550" border highlight-current-row @selection-change="checkHandler">
        <!--  @current-change="selectHandler" -->>
        <el-table-column  type="selection" width="40"></el-table-column>
        <el-table-column
          show-overflow-tooltip v-for="(x,i) in baseInfo" :key="i"
          :prop="x.key" :label="x.label" :fixed="x.fixed||false" :align="x.align||'center'"></el-table-column>
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <el-button size="mini" plain type="success" @click="openTalkHandler(scope.row)" :disabled="!scope.row.u_idCard">留言</el-button>
          </template>
        </el-table-column>
      </el-table>
      <Pagenation :pageData="pageData" @pageChange="pageChange"></Pagenation>
    </section>

    <!-- 模态框 查看模式 -->
    <DialogView
      ref="DialogView"
      :dialogTitle="dialogTitle"
      :formItems="formItems_"
      :formItems2="formItems2"
      dialogWidth="1000px" />

    <!-- 模态框 编辑模式 -->
    <DialogEdit
      ref="DialogEdit"
      :rules="rules"
      :dialogTitle="dialogTitle"
      :action="$api.url_upload_pu"
      :formItems="formItems"
      :formItems2="formItems2"
      @watchChange="watchChange"
      @submitHandler="editSubmitHandler"
      dialogWidth="1000px"
      :isShowArea="true" />

    <el-dialog
      title="导入提示"
      :close-on-click-modal="false"
      :visible.sync="isShowImportTip"
      :append-to-body="true"
      width="500px">
      <div v-html="importResult" style="text-align:left"></div>
    </el-dialog>

    
    <el-dialog
      :visible.sync="isShowTalk" :close-on-click-modal="false"
      title="留言" :append-to-body="true" center width="800px">
      <div class="talk-box">
        <div class="talk-item" :class="{'talk-item-right':x.sendId===userInfo.id}" v-for="(x,i) in historyTalk" :key="i">
          <p>
            <span class="talk-name" v-if="x.sendId!==userInfo.id">{{x.sendUser.name}}</span>
            <span class="talk-date">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{x.showDate}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="talk-name" v-if="x.sendId===userInfo.id">{{x.sendUser.name}}</span>
          </p>
          <div class="talk-content">
            <p>{{x.content}}</p>
            <el-image
              v-for="(x2,i2) in x.imgUrlList" :key="i2"
              style="width:100px;height:100px" :src="x2|toimg" fit="fill" :preview-src-list="x.imgUrlList|toimgs"></el-image>
          </div>
        </div>
      </div>
      <div class="talk-action">
        <el-input class="talk-input" type="textarea" clearable size="mini" :rows="5" v-model="tData.content" placeholder="请输入回复..."></el-input>
        <div class="talk-btns">
          <el-button type="" plain @click="clearTalkHandler">清 空</el-button>
          <el-button type="primary" @click="submitTalkHandler">发 送</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Loading } from 'element-ui'
import DialogEdit from '@/components/DialogEdit'
import DialogView from '@/components/DialogView'
// import AreaPicker from '@/components/AreaPicker_3'
import AreaPicker from '@/components/AreaPicker'
import Pagenation from '@/components/Pagenation'
import mixin_upload from '@/Mixins/mixin_upload'
import mixins from '@/Mixins/mixin_com'
import { powerMap } from '@/publicData/powerData'
export default {
  mixins: [mixins, mixin_upload],
  components: { AreaPicker, DialogView, DialogEdit, Pagenation },
  data() {
    return {
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 区别处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
      sign: 'zhan_song',
      dialogTitle: '送站信息',
      // fileName: 'qiyexinxi',

      filterForm: {
        user: {},
      },

      baseInfo: [
        // { key: 'province', label: '省' },
        // { key: 'city', label: '市' },
        // { key: 'county', label: '县' },
        // { key: 'town', label: '镇' },
        // { key: 'village', label: '村' },
        { key: 'areaName', label: '地区' },

        { key: 'startTime_', label: '出发时间' },
        { key: 'driverType', label: '出行方式' },
        { key: 'buyTypeText', label: '票务购买' },
        { key: 'o_name', label: '企业名称' },
        { key: 'u_nickName', label: '对象姓名' },
        { key: 'u_idCard', label: '对象身份证' },
        { key: 'driverNumber', label: '乘坐车次' },
        { key: 'sendPerson', label: '送站人员' },
        { key: 'receivePerson', label: '接站人员' },
        { key: 'cash', label: '垫付金额' },
      ],
      watchChangeKey: ['buyType'],
      defaultKeyValue: {
        buyType: 1
      },
      userList: [],
      rules: {
        // userId: [{ required: true, message: '必填', trigger: 'blur' }],
        // o_name: [{ required: true, message: '必填', trigger: 'blur' }],
        // startTime: [{ required: true, message: '必填', trigger: 'change' }],
        // driverType: [{ required: true, message: '必填', trigger: 'change' }],
        // buyType: [{ required: true, message: '必填', trigger: 'change' }],
        // number2: [{ trigger: 'blur', validator: this.$t.validator_number }],
      },
      // formItems: [
      //   { type: 'text', key: 'o_name', label: '企业名称' },
      //   { type: 'date', key: 'startTime', label: '出发时间' },
      //   { type: 'document', key: 'fileNameAndId', label: '输送人员名册', index: 1, limitNum: 5, accept: '.docx,.xlsx' },
      //   { type: 'image', key: 'fileNameAndId', label: '输送人员名册', index: 2, limitNum: 5, accept: '.docx,.xlsx' },
      //   { type: 'select_s', key: 'driverType', label: '出行方式', options: ['汽车','火车','飞机','其它'] },
      //   { type: 'select_s', key: 'buyType', label: '票务购买', options: [{label:'自行购票',value:1},{label:'公司代付',value:2}], isWatch: true },
      //   { type: 'select_s', key: 'userId', label: '对象身份证', options: this.userList, remoteMethod: this.getUesrData },
      //   { type: 'textarea', key: 'description', label: '处理意见' },
      //   // { type: 'text', key: 'cash', label: '垫付金额' },
      //   { type: 'video', key: 'o_videoUrl', label: '视频简介', index: 3 },
      // ],
      // formItems_: [
      //   { type: 'date', key: 'startTime', label: '出发时间' },
      //   { type: 'select_s', key: 'driverType', label: '出行方式', options: ['汽车','火车','飞机','其它'] },
      //   { type: 'select_s', key: 'buyType', label: '票务购买', options: [{label:'自行购票',value:1},{label:'公司代付',value:2}], isWatch: true },
      //   { type: 'text', key: 'o_name', label: '企业名称' },
      //   { type: 'text', key: 'u_idCard', label: '对象身份证' },
      // ],
      // formItems2: null,

      isShowTalk: false,
      tData: {},
      historyTalk: [
        // {sendUser:{name:'aaa'},user:{name:'bbb'},content:'内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容',topicId:'abc',showDate:'2020-10-19 10:11:43',imgUrlList:['','']},
        // {sendUser:{name:'bbb'},user:{name:'aaa'},content:'内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容',topicId:'abc',showDate:'2020-10-19 10:11:43',imgUrlList:['','']},
        // {sendUser:{name:'aaa'},user:{name:'bbb'},content:'内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容',topicId:'abc',showDate:'2020-10-19 10:11:43',imgUrlList:[]},
        // {sendUser:{name:'aaa'},user:{name:'bbb'},content:'内容内容内容内容内容内容内容内容',topicId:'abc',showDate:'2020-10-19 10:11:43',imgUrlList:[]},
      ],
    }
  },
  computed: {
    // importAction() {
    //   return this.$api.baseUrl + '/user/sync/company/' + this.userInfo.areaId
    // },
    formItems() {
      return [
        { type: 'date', key: 'startTime', label: '出发时间' },
        { type: 'select_s', key: 'driverType', label: '出行方式', options: ['汽车','火车','飞机','其它'] },
        { type: 'select_s', key: 'buyType', label: '票务购买', options: [{label:'自行购票',value:1},{label:'公司代付',value:2}], isWatch: true },
        { type: 'text', key: 'o_name', label: '企业名称' },
        { type: 'select_s', key: 'userId', label: '对象身份证', options: this.userList, remoteMethod: this.getUesrData, isWatch: true },
        { type: 'text', key: 'u_nickName', label: '对象姓名', disabled: true },
        { type: 'text', key: 'driverNumber', label: '乘坐车次' },
        { type: 'text', key: 'sendPerson', label: '送站人员' },
        { type: 'text', key: 'receivePerson', label: '接站人员' },
        // { type: 'number', key: 'cash', label: '垫付金额' },
      ]
    },
    formItems_() {
      return [
        { type: 'date', key: 'startTime_', label: '出发时间' },
        { type: 'select_s', key: 'driverType', label: '出行方式', options: ['汽车','火车','飞机','其它'] },
        { type: 'select_s', key: 'buyType', label: '票务购买', options: [{label:'自行购票',value:1},{label:'公司代付',value:2}], isWatch: true },
        { type: 'text', key: 'o_name', label: '企业名称' },
        { type: 'text', key: 'u_idCard', label: '对象身份证' },
        { type: 'text', key: 'u_nickName', label: '对象姓名' },
        { type: 'text', key: 'driverNumber', label: '乘坐车次' },
        { type: 'text', key: 'sendPerson', label: '送站人员' },
        { type: 'text', key: 'receivePerson', label: '接站人员' },
        { type: 'number', key: 'cash', label: '垫付金额' },
      ]
    },
    formItems2() {
      return null
    }
  },
  methods: {
    moveDiv() {
      let div = document.querySelector('.talk-box')
      div.scrollTop = div.scrollHeight - 440
      // div.scrollIntoView()
    },
    openTalkHandler(row) {
      let { id, userId } = row
      console.log(id, userId, this.userInfo.id)
      this.isShowTalk = true
      this.tData.topicId = id
      // this.tData.userId = userId
      this.tData.sendId = this.userInfo.id

      this.getTalkData()
    },
    getTalkData() {
      let rD= {
        topicId: this.tData.topicId,
        messageType: 1,
      }
      this.$api.util_search('zhan_liuyan', rD).then(res => {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c_R:`, 'color: #f00;', _R)
          this.historyTalk = _R.reverse()
      
          let timer = setTimeout(() => {
            this.moveDiv()
            clearTimeout(timer)
          }, 1)

        } else { this._status(res.data) }
      })
    },
    submitTalkHandler() {
      console.log(`%ctData:`, 'color: #00f;', this.tData)
      // this.historyTalk.push(
      //   {sendUser:{name:'aaa'},user:{name:'bbb'},content:'内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容',topicId:'abc',showDate:'2020-10-19 10:11:43',imgUrlList:['','']}
      // )
      this.tData.messageType = 1
      let { content } = this.tData
      if (!content) { this.$message.warning('请输入内容！') }
      else {
        this.$api.util_create('zhan_liuyan', this.tData).then(res => {
          if (res.data.status == 0) {
            this.$message.success('发送成功')
            this.clearTalkHandler()
            this.getTalkData()
          } else { this._status(res.data) }
        })
      }
    },
    clearTalkHandler() {
      this.tData.content = ''
    },
    modifyHandlerBefore() {
      let {
        user
      } = this.selectData
      console.log(user.u_idCard)
      this.userList = [
        {
          label: user.u_idCard,
          value: user.id,
        }
      ]
    },
    watchChange(data) {
      // console.log(`%caaaa:`, 'color: #f00;', data)
      switch (data.key) {
        case 'buyType':
          if (data.val === 1) {
            this.formItems.splice(9, 1)
          } else if (data.val === 2) {
            this.formItems.splice(9, 1, { type: 'number', key: 'cash', label: '垫付金额' })
          }
          break;
        case 'userId':
          let item = this.userList.find(x => x.value === data.val)
          console.log(item)
          this.$refs.DialogEdit.eData.u_nickName = item.nickName
          break;
      }
    },
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 区别处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
    editSubmitHandler(result) {
      console.log(`%cresult:`, 'color: #00f;', result)
//       let { id, province, city, county, town, village } = result
//       let rData = { province, city, county, town, village }
//       const mapList = [
// // ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 区别处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
//         'startTime',
//         'driverType',
//         'buyType',
//         'o_name',
//         'userId',
//         'driverNumber',
//         'sendPerson',
//         'receivePerson',
//         'cash',
// // ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 区别处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
//       ]
//       if (this.isCreate) {
//         mapList.forEach(x => {
//           result[x] ? rData[x] = result[x] : ''
//         })
//         console.log(rData)
        
//         this.$api.util_create(this.sign, rData).then(res => {
//           if (res.data.status == 0) {
//             this.$message.success('创建成功！')
//             this.$refs.DialogEdit.isShowDialog = false
//             this.$refs.DialogEdit.clearHandler()
//             this.searchHandler()
//           } else { this._status(res.data) }
//         })
//       }

//       else {
//         mapList.forEach(x => {
//           if (this.selectData[x] !== result[x]) {
//             rData[x] = result[x]
//           }
//         })
//         rData.id = this.selectData.id // 绑定修改的数据id
// // ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
//         rData.userId = this.selectData.userId
// // ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
//         console.log(rData)

//         this.$api.util_modify(this.sign, rData).then(res => {
//           if (res.data.status == 0) {
//             this.$message.success('修改成功！')
//             this.$refs.DialogEdit.isShowDialog = false
//             this.$refs.DialogEdit.clearHandler()
//             this.searchHandler()
//           } else { this._status(res.data) }
//         })
//       }
    },
    getData(rD = {}) {
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
      let { organization, personal, o_name, id } = this.userInfo
      console.log(`%corganization, personal:`, 'color: #00f;', o_name, organization, personal)
      if (organization) {
        rD.o_name = o_name
      } else if (personal) {
        rD.userId = id
      }
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
      this.$api.util_search(this.sign, rD).then( res=> {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c_R:`, 'color: #f00;', _R)
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
          // this.tableData = _R
          this.tableData = _R.map(x => {
            x.startTime_ = x.startTime
            x.startTime = new Date(x.startTime_).getTime()
            x.u_idCard = x.user ? x.user.u_idCard : ''
            x.u_nickName = x.user ? x.user.u_nickName : ''
            x.areaName = x.province + x.city + x.county + x.town + x.village
            x.buyTypeText = ['自行购票','公司代付'][x.buyType - 1]
            return x
          })
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
          this.pageData.total = res.data.size
        } else { this._status(res.data) }
      })
    },
    getUesrData(val) {
      console.log(val, this.areaIds_x)
      let rD = {
        areaId: this.areaIds_x[this.areaIds_x.length - 1],
        u_idCard: val,
        personal: true,
      }
      // console.log(rD)
      this.$api.getUserList(rD).then( res=> {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          this.userList = _R.map(x => {
            return {
              label: x.u_idCard,
              nickName: x.u_nickName || x.name,
              value: x.id,
            }
          })

          // 如果对话框里有切换的项目，修改前要先切换到对应的项目
          if(this.watchChangeKey) {
            let eData = this.$refs.DialogEdit.eData
            console.log(`%ceData:`, 'color: #f00;', eData)
            this.watchChangeKey.forEach(x => {
              this.watchChange({ key: x, val: eData[x] })
            })
          }
          console.log(`%c用户数据:`, 'color: #00f;', this.userList)
        } else { this._status(res.data) }
      })
    },
  },
  created() {
    // const powerList = this.userInfo.privilegesList
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
    // const powerStr = powerMap[this.sign]
    // const powerStr = powerMap[this.catalog]
    // console.log(powerStr)
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
    // const mapList = ['search','create','modify','delete','import','export']
    const mapList = ['search']
    // if (this.userInfo.admin) {
      mapList.forEach(x => {
        this.btnShow[x] = true
      })
    // } else {
    //   mapList.forEach(x => {
    //     if (x && powerList.includes(powerStr + '-' + x)) {
    //       this.btnShow[x] = true
    //     } else if (!x) {
    //       this.btnShow.search = true
    //     }
    //   })
    // }
  },
}
</script>

<style lang='scss' scoped>
.section-filter{display: flex;overflow-x: auto;}
.section-filter>div{flex-shrink: 0;}
.filter-col{display: flex;flex-direction: column;}
.filter-area{display: flex;}
.filter-area-label{margin:5px 10px 0 50px;font-size: 14px;}
.filter-btn{margin-left: 20px;}

.section-btns{padding-left: 15px;margin-right: 10px;display: flex;}
/deep/.section-btns .el-upload-list{display: none;}



.file-item{height: 40px;line-height: 40px;}
.file-name{display: inline-block;min-width: 120px;padding: 0 10px;}



.talk-box{
  width: 710px;height:440px;padding: 0 20px;
  border: 1px solid #DCDFE6;border-radius: 8px;overflow: auto;
}
.talk-item{display: flex;flex-direction: column;align-items: flex-start;padding: 10px;}
.talk-item-right{align-items: flex-end;}
.talk-name{font-size: 20px;}
.talk-date{font-size: 12px;}
.talk-content{
  width: fit-content;padding: 20px;margin: 10px 40px;
  border: 1px solid #DCDFE6;border-radius: 4px;background: #eee;position: relative;
}
.talk-content::after{
  content: '';
  display: inline-block;width: 20px;height: 20px;
  border-top:1px solid #DCDFE6;border-right:1px solid #DCDFE6;background: #eee;
  position: absolute;top:10px;left:-11px;right: auto;
  transform: rotate(225deg);
}
.talk-item-right .talk-content::after {
  right:-11px;left: auto;
  transform: rotate(45deg);
}
.talk-action{margin-top: 20px;display: flex;flex-direction: column;align-items: flex-end;}
.talk-input{font-size: 16px;}
.talk-btns{margin: 10px;}
</style>